import {translation} from "@2d-front-monorepo/core";
import {MaterialIcon} from "@2d-front-monorepo/design-library";
import {CreditCardProvider} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {usePermits} from "../hooks/usePermits";
import { Link } from "react-router";
import {PrivateRoutes} from "../routes";

export default function AddCreditCard(): JSX.Element | undefined {
	const {holderData, permits} = usePermits();
	const currentCardProvider = holderData.paymentProviders?.creditCardProvider ?? CreditCardProvider.Undefined;

	return currentCardProvider == CreditCardProvider.Undefined && permits.permits.length > 0
		? <div className="form-message form-message--warning">
			<p className="layout horizontal aligned middle credit-card-warning">
				<MaterialIcon icon="warning"/>
				<span className="credit-card-warning--text">{translation(PermitTranslations.payments_page__no_card)}</span>
				<span className="flex"></span>
				<Link to={PrivateRoutes.payments} className="form__button form__button--primary form__button--small">{translation(PermitTranslations.payments_page__add_new_card)}</Link>
			</p>
		</div>
		: undefined;
};
